module.exports = __webpack_public_path__ + "img/point_ending_p.0867fea4.svg";